module.exports = __webpack_public_path__ + "assets/0998d47e9b911f1de610c22254ff9c02.mp3";